// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function getNestedValue(obj: any, path: string) {
  const pathArray = path.split(".");
  return pathArray.reduce((accumulator, key) => {
    if (accumulator && typeof accumulator === "object" && key in accumulator) {
      return accumulator[key];
    }
    return undefined; // Or a default value if you prefer
  }, obj);
}
